import { route, string } from 'react-router-typesafe-routes/dom'
import { dateString } from '@/modules/shared/routes/codecs'

const base = 'et/company/:companyId/printoutsModule' as const
const companyOnly = { companyId: string().defined() }

export const PRINTOUT_ROUTES = {
  printoutList: route(`${base}/list`, { params: companyOnly }),
  printoutListWithDateRange: route(`${base}/list/from/:from/to/:to`, {
    params: {
      companyId: string().defined(),
      from: dateString.defined(),
      to: dateString.defined(),
    },
  }),
  favoritePrintouts: route(`${base}/favorites`, { params: companyOnly }),
  toSendPrintouts: route(`${base}/to-send`, { params: companyOnly }),
  scheduledPrintouts: route(`${base}/scheduled`, { params: companyOnly }),
}
